import React from "react";
import logoWhite from "../../../images/logo-white-horizontal.png";
import localeText from "../../../../locale";
import { Link } from "react-router-dom";
import LanguageSelectionButton from "../../../../components/LanguageSelectionButton/LanguageSelectionButton";

const LandingNav = (props) => {
  return (
    <div className="text-white font-semibold p-4 xl:px-8 gap-7 flex align-items-center flex-1">
      <Link to="/">
        <img
          src={logoWhite}
          alt="app-logo"
          style={{ width: "clamp(138px, 32vw, 244px)" }}
        />
      </Link>
      <div
        className="ml-auto gap-5 hidden xl:flex align-items-center vertical-align-baseline"
        style={{ minHeight: "50px" }}
      >
        <Link
          className="font-semibold text-white hover:underline p-0 focus:shadow-none "
          to="/#negocio"
          onClick={() => props.scrollToSection("negocio")}
        >
          {localeText("benefits")}
        </Link>
        <Link
          className="font-semibold text-white hover:underline p-0 focus:shadow-none "
          to="/#resources"
          onClick={() => props.scrollToSection("resources")}
        >
          {localeText("resources")}
        </Link>
        <Link
          className="font-semibold text-white hover:underline p-0 focus:shadow-none "
          to="/#plans"
          onClick={() => props.scrollToSection("plans")}
        >
          {localeText("plans")}
        </Link>
        <a
          href="https://extraconomy.blog/"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-white hover:underline"
        >
          {localeText("blog")}
        </a>
        <LanguageSelectionButton storePage={false} />
      </div>
    </div>
  );
};

export default LandingNav;
